import { useApolloClient } from 'react-apollo';
import gql from 'graphql-tag';
import { generateVotesPDF, generateCommentsPDF } from '../utils/pdf';
import useMe from './useMe';
import useToast from './useToast';

const userDisplayFragment = gql`
  fragment userDisplay_Part on User {
    _id
    name
    email
    condominiums {
      role
      data
      unity
    }
  }
`;

const commentsAssemblyDetailedFragment = gql`
  fragment commentsAssemblyDetailedFragment on CommentDetail {
    user {
      ...userDisplay_Part
    }
    text
    createdAt
    replies {
      text
      createdAt
      user {
        name
      }
    }
  }

  ${userDisplayFragment}
`;

const votesUserFragment = gql`
  fragment votesUserFragment on AssemblyUser {
    name
    condominiums {
      data
      role
      unity
    }
  }
`;

const optionVotesDescriptionReportsFragment = gql`
  fragment optionVotesDescriptionReportsFragment on OptionDetail {
    description
    votes {
      ...votesUserFragment
    }
  }
  ${votesUserFragment}
`;

const getGql = gql`
  query assembly($_id: ID!, $detailed: Boolean, $withCondominium: Boolean) {
    assembly(_id: $_id, detailed: $detailed, withCondominium: $withCondominium) {
      _id
      description
      condominium
      type
      status
      subjects {
        _id
        title
        description
        options {
          ...optionVotesDescriptionReportsFragment
        }
        comments {
          ...commentsAssemblyDetailedFragment
        }
      }
      openingDate
      endDate
    }
    condominium {
      _id
      name
    }
  }
  ${commentsAssemblyDetailedFragment}
  ${optionVotesDescriptionReportsFragment}
`;

export default function useReports() {
  const [me] = useMe();
  const apolloClient = useApolloClient();

  const toast = useToast();

  const getData = async assemblyId => {
    const { data } = await apolloClient.query({
      query: getGql,
      variables: {
        _id: assemblyId,
        detailed: true,
        withCondominium: true,
      },
    });
    return data;
  };

  const showToast = () =>
    toast.fire({
      icon: 'success',
      title: `Aguarde, gerando relatório`,
    });

  const commentsReport = async assemblyId => {
    if (assemblyId) {
      showToast();
      const { assembly, condominium } = await getData(assemblyId);
      generateCommentsPDF({ assembly, condominium, me });
    }
  };
  const votesReport = async assemblyId => {
    if (assemblyId) {
      showToast();
      const { assembly, condominium } = await getData(assemblyId);
      generateVotesPDF({ assembly, condominium, me });
    }
  };
  return { commentsReport, votesReport };
}
